export const DEFAULT_LISTING_INSTRUCTION = 'Choose one approved business whose evidence supports this article’s angle. Use null if no suitable unused business remains.';
export function listingAiAttributes(attrs, enabled, id) {
  return enabled ? { aiListingSlotId: attrs.aiListingSlotId || id, aiListingInstruction: attrs.aiListingInstruction || DEFAULT_LISTING_INSTRUCTION, listingId: null, snapshot: null } : { aiListingSlotId: null, aiListingInstruction: null };
}
export function collectListingAiSlots(document) {
  const slots = []; const seen = new Set();
  function visit(node, protectedAncestor = false) {
    if (!node || typeof node !== 'object') return;
    const attrs = node.attrs || {};
    const protectedBlock = protectedAncestor || ['edit', 'move', 'remove'].some(key => attrs.blockLock?.[key]);
    const id = attrs.aiListingSlotId;
    if (id != null && id !== '') {
      if (node.type !== 'listingCard' || typeof id !== 'string' || !/^[a-zA-Z0-9][a-zA-Z0-9_-]{7,127}$/.test(id) || seen.has(id)) throw new Error('AI listing slots require unique valid IDs on listing cards.');
      if (protectedBlock) throw new Error('AI listing cards cannot be protected by locks on themselves or ancestors.');
      const instruction = typeof attrs.aiListingInstruction === 'string' ? attrs.aiListingInstruction.trim() : '';
      if (!instruction || instruction.length > 2000) throw new Error('Every AI listing card requires a placement instruction of 1–2,000 characters.');
      if (attrs.listingId || attrs.snapshot) throw new Error('AI listing cards cannot also contain a manually assigned listing.');
      seen.add(id); slots.push({ slotId: id, instruction });
    } else if (attrs.aiListingInstruction) throw new Error('A placement instruction requires an AI listing slot ID.');
    for (const child of node.content || []) visit(child, protectedBlock);
  }
  visit(document);
  if (slots.length > 20) throw new Error('Templates support at most 20 AI listing cards.');
  return slots;
}
